export default __webpack_public_path__ + "media/images/images_v2/top-onglet-c42dad0b500e57bddcd4fc7f943a88cb.png";